module.exports = __webpack_public_path__ + "img/45.8486f30d.jpg";